import { render } from "./TenantHeaderDetails.vue?vue&type=template&id=77b98aca&ts=true"
import script from "./TenantHeaderDetails.vue?vue&type=script&lang=ts"
export * from "./TenantHeaderDetails.vue?vue&type=script&lang=ts"

import "./TenantHeaderDetails.vue?vue&type=style&index=0&id=77b98aca&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__